import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { GroupState, GroupType } from './groupTypes'

const initialState: GroupState = {
  selectedGroup: null,
  groups: []
}

const groupSlice = createSlice({
  name: 'group',
  initialState,
  reducers: {
    setSelectedGroup(
      state,
      action: PayloadAction<GroupState['selectedGroup']>
    ) {
      state.selectedGroup = action.payload
    },
    setGroups(state, action: PayloadAction<GroupType[]>) {
      state.groups = action.payload
    }
  }
})

export const groupReducer = groupSlice.reducer
